<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		<!-- banner -->
		<qBanner></qBanner>




		<div class="read">
			<div class="read-hd">
				<q-title title="住院预缴" :time="time" @remain-time="remainTime"></q-title>
				<q-step :step="3"></q-step>
			</div>


			
			
			<div  class="read-bd-title fc"><i ></i><h3 >预约信息</h3></div>
			
			
			<!-- 01：金额为0 -->
			<div class="k-box b1" >
				<div class="book-info fc-bet" style="height: 240px;">
					<div class="flex1">
						<div class="fc ">
							<div class="left">
								<img src="../../assets/people.png" >
							</div>
							<div class="right flex1">
								<div class="fc-bet">
									<div>
										<span>预约时间：</span><b>2021-12-05</b>
									</div>
									<div>
										<span>就诊医生：</span><b>张三</b>
									</div>
								</div>
								<div class="fc-bet">
									<div>
										<span>就诊时段：</span><b>08:00-08:30</b>
									</div>
									<div>
										<span>医院级别：</span><b>副主任</b>
									</div>
								</div>
								<div class="fc-bet">
									<div>
										<span>就诊科室：</span><b>呼吸内科</b>
									</div>
									<div>
										<span>挂号金额：</span><b style="color:#FF1111;">15元</b>
									</div>
								</div>
							</div>
						</div>
						
					
					</div>
					
				</div>
			</div>



				<div class="read-bd-title fc"><i></i>
					<h3>请选择支付方式</h3>
				</div>

				<div class="k-box">
					<div class="fc-bet pay-select xs">
						<a class="pay-item fcc" @click="payClick(1)">
							<div class="icon"><img src="../../assets/pay-alipay2.png"></div>
							<p>
								支付宝支付
							</p>
						</a>
						<a class="pay-item fcc" @click="payClick(2)">
							<div class="icon">
								<img src="../../assets/pay-weixin2.png">
							</div>
							<p>
								微信支付
							</p>
						</a>
						<a class="pay-item fcc" @click="payClick(3)">
							<div class="icon">
								<img src="../../assets/read-img5.png">
							</div>
							<p>
								医保支付
							</p>
						</a>
					</div>
				</div>



				<div class="foot-buttons fc-bet">
					<a href="/" class="btn-home fcc">
						<img src="../../assets/icon/icon-home.png">
						<span>首页</span>
					</a>

					<a class="btn-return fcc" @click="returnStep()">
						<img src="../../assets/icon/icon-return.png">
						<span>返回</span>
					</a>
				</div>
			
		
		
		
		</div>
		
		<!-- 微信支付 -->
		
		<div class="pay-weixin-box" v-if="showPayPop">
			<div class="user-info-row fcc">
				<div>
					<span>姓名：</span>
					<b>张三</b>
				</div>
				<div>
					<span>性别：</span>
					<b>男</b>
				</div>
				<div>
					<span>门诊号码：</span>
					<b>95271</b>
				</div>
			</div>
			<div class="h1">
				请扫描屏幕中间二维码，付款成功后请耐心等候！
			</div>
			<div class="pay-body">
				<div class="img">
					<img src="../../assets/pay-weixin-eg.jpg"  v-if="payStyle==2">
					<img src="../../assets/pay-alipay-eg.jpg" v-if="payStyle==1">
				</div>
				
				<div class="txt">
					<p>本次支付金额为</p>
					<div class="money">
						3541.65元
					</div>
					<div class="code">
						<img src="../../assets/pay-code.png" >
					</div>
					<p class="tips">
						{{payTime}}秒后自动关闭
					</p>
					
					<button type="button" class="btn-cancle" @click="cancle">
						取消交易
					</button>
					
				</div>
			</div>
			<div class="tips-box">
				<h4>温馨提示：</h4>
				<p>
					1、按照左边的图示步骤进行操作；<br>
					2、扫二维码支付成功后请耐心等待，取走缴费凭条；<br>
					3、更换支付方式，请点【取消交易】按钮；
				</p>
			</div>
		</div>
		
		
		
		
		<qYibao v-if="showYibao" ref="yibao"></qYibao>
		
	</div>
</template>

<script>
	import qHead from '@/components/q-head/q-head.vue';
	import qBanner from '@/components/q-head/q-banner.vue';
	import qTitle from '@/components/q-read/q-title.vue';
	import qStep from '@/components/q-read/q-step.vue';
	
	import qYibao from '@/components/q-pop/q-pop-yibao.vue';
	
	
	export default {
		components: {
			qHead,
			qBanner,
			qStep,
			qTitle,qYibao
		},
		data() {
			return {
				number:null,
				speedNumArr:[
					500,1000,2000,3000,5000
				],
				speedNumArrIndex:null,

				time:86,
				// 支付方式
				showPayPop:false,
				payStyle:1  ,//1支付宝 。2微信
				//支付剩余时间
				payTime:60,
				
				
				showYibao:false
			}
		},
		mounted() {

		},
		methods: {
			speedNumber(item,index){
				this.number=item
				this.speedNumArrIndex=index
			},
			
			payClick(i){
				this.time=60
				if(i==3){
					// 医保
					this.showYibao=true
					this.$refs.yibao.show=true
				}else{
					this.showPayPop=true
				}
				this.payStyle=i
				
				
				
				
				
			},
			remainTime(data){
				this.payTime=data
			},	
			cancle(){
				this.time=86
				this.showPayPop=false
				this.payStyle=1
			}
			
		},
		beforeDestroy() {
			//clearInterval(this.timer);
		}

	}
</script>

<style scoped lang="less">

</style>
